const formatTime = Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).format


const formatDate = Intl.DateTimeFormat('ru-RU', {
year: 'numeric',
month: 'long',
day: 'numeric',
}).format  

export const safeFormatTime = (value) => {
    if (!value)
        return value;
    if (!value.trim())
        return value;

    try {
        const result = formatTime(new Date(value));
        return result;
    } catch (e) {
        console.error(e.message);
    }

    return value;
}

export const safeFormatDate = (value) => {
    if (!value)
        return value;
    if (!value.trim())
        return value;

    try {
        const result = formatDate(new Date(value));
        return result;
    } catch (e) {
        console.error(e.message);
    }

    return value;
}